import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
// import { LocalDataService } from '../almacenamiento/local-data.service';
import { MensajesProvider } from '../mensajes/mensajes';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class ManejadorDeErroresService {

  constructor(
    private navCtrl: NavController,
    private mensajesService: MensajesProvider,
    private storage: Storage,
    // private localDataService: LocalDataService,
  ) { }

  public async manejadorErroresNotificacion(error: any): Promise<boolean> {
    return new Promise<boolean>(async resolve => {
      console.log({ error });

      let title = 'Algo ha salido mal. 😥';
      let message = 'Error desconocido ...';


      if (error && error.status !== undefined && error.status >= 0) {

        switch (error.status) {
          case 0:
            if (error.message && error.message !== '') {

              message = `No se puede acceder al servicio,
            el servidor rechazó la conexión
            ERR_CONNECTION_REFUSED
            ${error.message}`;

              // await this.mensajesService.alertaInformativa(message);
            } else {
              message = `No se puede acceder al servicio,
            el servidor rechazó la conexión
            ERR_CONNECTION_REFUSED`;

              // await this.mensajesService.alertaInformativa(
              //   `No se puede acceder al servicio API,
              //    el servidor rechazó la conexión
              //    ERR_CONNECTION_REFUSED`);
            }
            break;
          case 401:
            if (error.error && error.error.Hint === 'Favor de validar password.') {
              // this.mensajesService.alertaInformativaPromise(error.error.Hint, error.error.Message);
              message = error.error.Message;
              title = error.error.Hint;
            } else {

              if (error.error !== undefined && error.error.Message && error.error.Message !== 'The underlying provider failed on Open.') {
                // this.storage.remove('passCard');
                this.boorrarLlavesLogOut();

                message = error.error.Message;
                title = error.error.Hint;
                this.goToLogIn();
              } else if (error.error.Message === 'The underlying provider failed on Open.') {
                message = error.error.Message;
                title = error.error.Hint;
              }
              else {
                // borrar del storage
                // this.storage.remove('passCard');
                this.boorrarLlavesLogOut();

                message = 'Por favor vuelva a introducir sus credenciales.';
                title = 'Su sesión ha caducado.';
                // await this.mensajesService
                // .alertaInformativaPromise('Su sesión ha caducado', 'Por favor vuelva a introducir sus credenciales.');
                this.goToLogIn();
              }
            }
            break;
          case 500:
            if (error._body) {
              const errorAPI = JSON.parse(error._body);
              if (errorAPI && errorAPI.Message && errorAPI.Message !== '') {
                // this.mensajesService.alertaInformativaPromise(errorAPI.Hint, errorAPI.Message);
                message = errorAPI.Message;
                title = errorAPI.Hint;
              }
            } else if (error.error) {
              if (error.error.Hint && error.error.Message) {
                // this.mensajesService.alertaInformativaPromise(error.error.Hint, error.error.Message);
                message = error.error.Message;
                title = error.error.Hint;
              } else if (error.error.message && error.error.hint) {
                message = error.error.message;
                title = error.error.hint;
              } else {
                // this.mensajesService.alertaInformativaPromise(error.error.Message, error.error.ExceptionMessage);
                message = error.error.ExceptionMessage;
                title = error.error.Message;
              }
            } else {
              // await this.mensajesService.alertaInformativa('Error desconocido 500');
              message = 'Error desconocido 500';
            }


            break;
          default:
            // await this.mensajesService.alertaInformativa('Error desconocido');
            message = 'Error desconocido';
            break;
        }



      } else if (error.xhr && error.xhr) {
        switch (error.xhr.status) {
          case 401:
            if (error.error !== 'The underlying provider failed on Open.') {
              // this.storage.remove('passCard');
              this.boorrarLlavesLogOut();
              message = error.error;
              title = error.error;
              // this.mensajesService.alertaInformativaPromise(error.error.Hint, error.error.Message);
              this.goToLogIn();
            } else {
              message = error.error;
              title = error.error;
            }
            break;
          default:
            const errorAjax = JSON.parse(error._body);
            if (errorAjax && errorAjax.Message && errorAjax.Message !== '') {
              // this.mensajesService.alertaInformativaPromise(errorAjax.Hint, errorAjax.Message);
              message = errorAjax.Message;
              title = errorAjax.Hint;
            }
            break;
        }
      } else {
        if (error.error !== undefined && error.error.Message) {
          // this.mensajesService.alertaInformativaPromise(error.error.Hint, error.error.Message);
          message = error.error.Message;
          title = error.error.Hint;

        } else if (error.message) {
          if (error.message.includes('unknown url')) {
            // this.mensajesService.alertaInformativaPromise('Valide su conexión a internet', error.message);
            message = error.message;
          } else {
            // this.mensajesService.alertaInformativa(error.message);
            message = error.message;
          }
        } else if (error.Message) {
          message = error.Message;
          // this.mensajesService.alertaInformativa(error.Message);
        }
      }

      try {
        // this.createAccessLogFileAndWrite(`${title} - ${message}`);
      } catch (error) {
        console.log('ERROR al escribir el archivo de LOG');
      } finally {
        await this.mensajesService.alertaInformativaPromise(title, message);
        resolve(true);
      }
      resolve(false);
    });

  }

  public goToLogIn() {
    this.navCtrl.navigateRoot('/log-in', { animated: true });
  }

  public eliminarLlave(strKey: string): Promise<boolean> {
    const promesa = new Promise<boolean>((resolve, reject) => {
      this.storage.ready().then(async () => {
        // borrar del storage
        await this.storage.remove(strKey);
        resolve(true);
      }, (error) => {
        resolve(false);
      }).catch(error => {
        resolve(false);
      });
    });
    return promesa;
  }

  public async boorrarLlavesLogOut() {

    await this.eliminarLlave('passCard');
    await this.eliminarLlave('DataInventario');
    await this.eliminarLlave('DataInventarioAgrupado');
    await this.eliminarLlave('filtroInventario');
    await this.eliminarLlave('objFiltroTareasPendientes');

  }

}
